import { computed } from "vue";
import { useStore } from "vuex";
import {
  diningCardsEnabled,
  allowChangingCardNumbers,
} from "@/modules/settings/queries/tenantSettingsSelectors";

export function useCanEditDiningCard() {
  const store = useStore();
  return computed(() => {
    if (!diningCardsEnabled.value) return false;
    if (store.getters["auth/isCustomer"]) return allowChangingCardNumbers.value;
    if (store.getters["auth/isInstitutionsAdmin"]) {
      const perms = store.getters["auth/permissions"];
      return Array.isArray(perms) && perms.includes("children_edit");
    }
    return true;
  });
}
